export async function parseCsvCodes(file: File): Promise<string[]> {
  const text = await file.text();
  const clean = text.replace(/^\uFEFF/, '');
  return clean
    .split(/[\r\n,]+/)
    .map((cell) => cell.trim())
    .filter((cell) => cell.length > 0);
}
